import BarChart from '../widget/BarChart.vue'
import PieChart from '../widget/PieChart.vue'
import PlainPieChart from '../widget/PlainPieChart.vue'
import MeterChart from '../widget/MeterChart.vue'
import TableChart from '../widget/TableChart.vue'
import NiceTableChart from '../widget/NiceTableChart.vue'
import RollingBoard from '../widget/RollingBoard.vue'

export const WIDGET_MAP = {
  bar: BarChart,
  pie: PieChart,
  plainPie: PlainPieChart,
  meter: MeterChart,
  table: TableChart,
  niceTable: NiceTableChart,
  rollingBoard: RollingBoard
}

export const KPI_REGISTRY = [
  { id: 1001, name: '当月安全隐患类别', widget: 'pie' },
  { id: 1002, name: '当月各区域安全隐患发现数量', widget: 'bar' },
  { id: 1003, name: '当月安全隐患发现数员工排名', widget: 'bar' },
  { id: 1004, name: '当月安全积分员工排名', widget: 'bar' },
  { id: 1017, name: '违规计分员工排名', widget: 'bar' },
  { id: 1005, name: '区域风险大小排名', widget: 'niceTable' },
  { id: 1006, name: '实时作业动态', widget: 'rollingBoard' },
  { id: 1016, name: '实时特殊作业动态', widget: 'rollingBoard' },
  { id: 1007, name: '安全隐患实时动态', widget: 'rollingBoard' },
  { id: 1008, name: '安全隐患汇报总数', widget: 'meter' },
  { id: 1009, name: '线上培训人次', widget: 'meter' },
  { id: 1010, name: '参加考试人次', widget: 'meter' },
  { id: 1011, name: '风险评估次数', widget: 'meter' },
  { id: 1012, name: '特殊作业次数', widget: 'meter' },
  { id: 1013, name: '安全隐患排查次数', widget: 'meter' },
  { id: 1014, name: '安全隐患到期整改率', widget: 'meter', percent: true },
  { id: 1015, name: '安全隐患整改率', widget: 'meter', percent: true },
  { id: 1018, name: '风险识别数', widget: 'meter' }
]

export const KPI_MAP = KPI_REGISTRY.reduce((acc, item) => {
  acc[item.id] = item
  return acc
}, {})

export const METER_KPIS = KPI_REGISTRY.filter((item) => item.widget === 'meter')
export const CHART_KPIS = KPI_REGISTRY.filter((item) => item.widget !== 'meter')

export function getKpiDefinition(kpiId) {
  return KPI_MAP[kpiId]
}

export function getWidgetComponent(kpiId) {
  const definition = getKpiDefinition(kpiId)
  return definition ? WIDGET_MAP[definition.widget] : null
}
